import styled from 'styled-components';
import Grid from '@mui/material/Grid';

const TitleText = styled.p`
  font-weight: bold;
  margin: 0.5rem 0;
`;

type ChipItem = {
  label: string;
  value: any;
  type: string;
};

type ChipInputListProps = {
  chipsToInclude: Array<ChipItem> | Array<any>;
  chipsToExclude: Array<ChipItem> | Array<any>;
  renderChip: (listType: string, chip: Record<any, any> | ChipItem) => JSX.Element;
  renderChipInput: () => JSX.Element;
};

const ChipInputList = ({
  chipsToInclude,
  chipsToExclude,
  renderChip,
  renderChipInput,
}: ChipInputListProps) => {
  return (
    <Grid container alignContent="flex-start">
      {renderChipInput()}
      <Grid size={{ xs: 12, md: 5 }}>
        <TitleText>Include tags: </TitleText>
        {chipsToInclude.map((chip: ChipItem | Record<any, any>) => renderChip(chip.type, chip))}
      </Grid>
      <Grid size={{ xs: 12, md: 5 }}>
        <TitleText>Exclude tags: </TitleText>
        {chipsToExclude.map((chip: ChipItem | Record<any, any>) => renderChip(chip.type, chip))}
      </Grid>
    </Grid>
  );
};

export default ChipInputList;
